import React, { useEffect, useState } from 'react'
import { PageTitle } from '../../layout/core'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

const YoutubePage = () => {
  const [videos, setVideos] = useState([])
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<any>('')
  const navigate = useNavigate()

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_RESUME_PARSER_URL}/youtube-reply/get_channel_videos?channel_id=UCtyFO0Ozi8TeWsfSq-NzOTA`
        )
        setVideos(response.data.videos)
        setLoading(false)
      } catch (err) {
        setError('Failed to fetch videos. Please try again later.')
        setLoading(false)
      }
    }

    fetchVideos()
  }, [])

  // const videos = {
  //   channel_id: 'UCtyFO0Ozi8TeWsfSq-NzOTA',
  //   total_videos: 2,
  //   videos: [
  //     {
  //       video_id: 'ohQva6ogA24',
  //       title: '855976 hd 1920 1080 25fps',
  //       description: '',
  //       published_at: '2025-03-31T06:32:34Z',
  //       thumbnail: 'https://i.ytimg.com/vi/ohQva6ogA24/hqdefault.jpg'
  //     },
  //     {
  //       video_id: 'wj8BrzuZZi0',
  //       title: 'Butterfly',
  //       description: '',
  //       published_at: '2025-03-28T10:06:08Z',
  //       thumbnail: 'https://i.ytimg.com/vi/wj8BrzuZZi0/hqdefault.jpg'
  //     }
  //   ]
  // }

  const handleVideoClick = (videoId: string) => {
    navigate(`/youtube/video/${videoId}`)
  }

  if (loading)
    return (
      <div className='flex justify-center items-center h-64 text-lg font-semibold text-gray-700'>
        Loading videos...
      </div>
    )
  if (error)
    return (
      <div className='flex justify-center items-center h-64 text-red-600 font-medium'>{error}</div>
    )

  return (
    <>
      <PageTitle breadcrumbs={[]}>Youtube Channel Videos</PageTitle>
      <div className='px-4 py-2'>
        <div className='bg-white rounded-lg overflow-hidden px-4 py-2'>
          <div>
            <select
              className='form-select form-select-solid form-select my-4 py-4'
              style={{ width: 'fit-content' }}
              disabled
            >
              <option value='All'>All Videos</option>
              <option value='Recent'>Recently Uploaded</option>
              <option value='Popular'>Most Popular</option>
              <option value='Oldest'>Oldest First</option>
            </select>
          </div>

          {videos.length > 0 ? (
            <div className='table-responsive border border-muted rounded-2'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bolder fs-6 text-primary bg-light-primary'>
                    <th className='ps-4 border-end min-w-100px'>S.No</th>
                    <th className='ps-4 border-end min-w-100px'>Thumbnail</th>
                    <th className='ps-4 border-end min-w-100px'>Video Title</th>
                    <th className='ps-4 border-end min-w-100px'>Published Date</th>
                    <th className='ps-4 border-end min-w-100px'>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {videos.map((video: any, index: number) => (
                    <tr
                      key={video.video_id}
                      className='hover:bg-gray-50 transition-colors duration-200'
                    >
                      <td className='px-6 py-4'>
                        <div className='fw-bold fs-6 text-primary'>{index + 1}.</div>
                      </td>
                      <td className='px-6 py-4 whitespace-nowrap'>
                        <img
                          src={video.thumbnail}
                          alt={video.title}
                          className='object-cover rounded'
                          style={{ height: '10rem' }}
                        />
                      </td>
                      <td className='px-6 py-4'>
                        <div className='text-sm font-medium text-gray-900'>{video.title}</div>
                      </td>
                      <td className='px-6 py-4 whitespace-nowrap'>
                        <div className='text-sm text-gray-500'>
                          {new Date(video.published_at).toLocaleDateString()}
                        </div>
                      </td>
                      <td className='px-6 py-4'>
                        <button
                          onClick={() => handleVideoClick(video.video_id)}
                          className='btn btn-primary'
                        >
                          View Comments
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className='text-center p-8 text-gray-600'>No videos found for this channel.</div>
          )}
        </div>
      </div>
    </>
  )
}

export default YoutubePage
